import React from 'react';
import styles from './MentorBlock.module.css';
import myPhoto from '../../assets/img/myPhoto.jpg';

export default function MentorBlock() {
  return (
    <section id="2" className={styles.container}>
      <div className={styles.title}>Автор та куратор програми</div>
      <div className={styles.content_wrapper}>
        <img className={styles.myPhoto} src={myPhoto} />
        <div className={styles.text}>
          <p>
            Мене звати <strong>Наталія</strong>, я сертифікований нутриціолог із понад шістьма
            роками досвіду. Я допомагаю жінкам покращити свою фігуру, нормалізувати вагу та
            сформувати здорові харчові звички — без жорстких обмежень, стресу чи виснажливих дієт.
          </p>

          <p>
            Мій шлях у нутриціологію почався з особистого досвіду. Колись я й сама шукала відповідь
            на запитання: як харчуватися смачно, жити повноцінно й водночас виглядати та почуватися
            добре? Саме тоді я вирішила заглибитися в тему професійно — вивчила сучасні підходи до
            нутриціології та психології харчування.
          </p>

          <p>
            Сьогодні я працюю з жінками, які прагнуть схуднути, відчути легкість у тілі та повернути
            впевненість у собі. У своїх програмах я пропоную{' '}
            <strong>готові меню з можливістю автоматичної заміни продуктів</strong>, постійний
            супровід і підтримку в Telegram.
          </p>

          <p>
            Мій підхід — це <strong>турбота, повага до себе та реальні результати</strong>. Якщо ви
            готові до змін — я поруч, аби підтримати вас на цьому шляху.
          </p>
        </div>
      </div>
    </section>
  );
}
